<script>
import { mapState } from 'vuex';
import TwTitleBar from './TwTitleBar';

export default {
  name: 'DefaultWrapper',
  components: {
    TwTitleBar,
  },
  computed: {
    ...mapState({
      breadcrumbs: state => state.nav.breadcrumbs,
    }),
  },
};
</script>

<template>
  <v-content>
    <v-flex>
      <template v-if="breadcrumbs">
        <tw-title-bar
          :title="breadcrumbs.title"
          :breadcrumbs="breadcrumbs.breadcrumbs"
        />
      </template>
      <v-container class="ma-0">
        <v-layout row>
          <v-flex xs12>
            <v-card>
              <slot/>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/components/TwContentWrapper.vue